import byteSize from "byte-size";

export const byteToString = (size) => {
  function toStringFn() {
    return `${this.value}${this.unit}`;
  }

  return `${byteSize(size, { toStringFn })}`;
};
